export const BackofficeTableStyle = () => (
  <style>{`
    .MuiTableCell-root {
      background-color: transparent;
      border: none;
    }
    .MuiTableCell-root:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    .MuiTableCell-root:last-child {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
    .MuiTableBody-root > .MuiTableRow-root:nth-child(2n + 1) {
      background-color: #f5f5f5;
    }
    .MuiSelect-select.MuiInputBase-input.Mui-disabled {
      background-color: var(--flora--colors-actionNavigationStandardDisabled);
      padding: 14px;
    }
  `}</style>
)
